<script setup lang="ts">
  import { computed } from "vue";
  import { IconClients, IconTablet, IconSales } from "@ui-kit";
  import { type OrderType } from "@src/api";

  const { type, size = 32 } = defineProps<{ type?: OrderType | string; size?: number }>();

  const icon_style = computed(() => ({ width: `${size}px`, height: `${size}px` }));
</script>

<template>
  <IconSales
    v-if="type === 'pickup.commerce'"
    :style="icon_style"
    data-testid="order-item-type-pickup-commerce"
  />
  <IconTablet
    v-else-if="type === 'pickup.device'"
    :style="icon_style"
    data-testid="order-item-type-pickup-device"
  />
  <IconClients v-else :style="icon_style" data-testid="order-item-type-pickup" />
</template>
